import * as tools from '../Tools';
export default class Accordion {

    constructor() {
        this.init();
    }

    async init() {
        document.querySelectorAll('.ckedit .collapsible').forEach(function (div) {
            if (Math.floor(parseFloat(window.getComputedStyle(div).height)) < 140) {
                div.nextElementSibling.remove();
                div.classList.remove('collapsible');
                div.removeAttribute('aria-labelledby');
            } else {
                div.classList.remove('expanded');
                div.nextElementSibling.addEventListener('click', function () {
                    /** @type {HTMLButtonElement} */
                    var btn = this;
                    div.classList.toggle('expanded');
                    if (div.classList.contains('expanded')) {
                        btn.textContent = 'Einklappen';
                        btn.setAttribute('aria-expanded', 'true');
                    } else {
                        btn.textContent = 'Weiterlesen';
                        btn.setAttribute('aria-expanded', 'false');
                    }
                });
            }
        });
        document
            .querySelectorAll('div.accordion')
            .forEach((el: HTMLElement) => this.initToggle(el));
    }

    initToggle(el: HTMLElement) {
        const body = <HTMLElement>el.nextElementSibling;
        if (!body || !body.classList.contains('accordion-body')) {
            return;
        }
        const btnToggle: HTMLElement = el.querySelector('.toggle');
        btnToggle.addEventListener('click', () => this.toggle(btnToggle, body));
    }

    toggle(btnToggle: HTMLElement, body: HTMLElement) {
        body.classList.toggle('expanded');
        tools.toggleCSSclasses(btnToggle, 'icon-right-circle', 'icon-down-circle');
        const ev = new CustomEvent('onAccordionToggle',{ detail :
            {
                expanded: body.classList.contains('expanded')
            }
        });
        document.dispatchEvent(ev);
    }

}
